import React, { useEffect } from "react";
import MetaTags from "components/meta";
import Navbar from "components/Navbar";
import Footer from "components/footer";
import { horseFilter } from "store/horseFilter";
import { googleReviewsStore } from "store/googleReviews";
import ReactGA from "react-ga4";

export default function BaseLayout(props) {
  const {
    meta,
    children,
    data: { horseFilters, header, footer, social, googleReviews },
    location,
  } = props;

  const { setFilters } = horseFilter();
  const { setGoogleReview } = googleReviewsStore();

  useEffect(() => {
    if (horseFilters) setFilters(horseFilters.filters);
    if (googleReviews) setGoogleReview(googleReviews.result);

    ReactGA.initialize("UA-141179109-1");
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location?.pathname]);

  return (
    <>
      <Navbar data={header} social={social} />
      {children}
      <Footer data={footer} social={social} />
    </>
  );
}
